<template>
	<VDataGridV2
    :loader="dataLoader"
    sticky
    draggable-rows
    paginated
    entity-type="contractExternal"
    class="contracts-external-registry"
		:context-menu="ContractsExternalService.contextMenu"
		@row:dblclick="row => openManualContractDialog(row.id)"
	>
		<VDataGridColumnV2
			id="id"
			label="№"
			width="250px"
			content-align="left"
			filterable
			filter-send-name="numberPattern"
			:filter-props="{ placeholder: '№', clearable: true }"
			content-class="ellipsis"
		>
			<template #default="{ row }">
				<VLink
          class="ellipsis"
					@click="openManualContractDialog(row.id)"
				>
					{{ row.number }}
				</VLink>
			</template>
		</VDataGridColumnV2>

		<VDataGridColumnV2
			id="seller"
			label="Поставщик"
			width="250px"
			content-align="left"
			filterable
      filter-identity="*"
			filter-type="select"
			:filter-props="{
				placeholder: 'Название поставщика',
				dataUrl:     'partners.getList',
				searchable:  true,
				clearable:   true,
			}"
			content-class="ellipsis"
		>
			<template #default="{ row }">
        {{ row.seller.name }}
			</template>
		</VDataGridColumnV2>

		<VDataGridColumnV2
			id="sellerCompany"
			label="Юр. лицо поставщика"
			width="250px"
			content-align="left"
			filterable
      filter-identity="*"
			filter-type="select"
			:filter-props="{
				placeholder: 'Название поставщика',
				dataUrl:     'partners.getList',
				searchable:  true,
				clearable:   true,
			}"
			content-class="ellipsis"
		>
			<template #default="{ row }">
        {{ row.sellerCompany.name }}
			</template>
		</VDataGridColumnV2>

		<VDataGridColumnV2
			id="buyer"
			label="Покупатель"
			width="200px"
			content-align="left"
			content-class="ellipsis"
		>
			<template #default="{ row }">
        {{ row.buyer.name }}
			</template>
		</VDataGridColumnV2>

		<VDataGridColumnV2
			id="vatType"
			label="НДС"
			width="125px"
			content-align="center"
			content-class="nowrap"
		>
			<template #default="{ row }">
				<template v-if="row.sellerCompany.isVatPayer === false">
					<div>Не облагается</div>
				</template>
				<template v-else>
					<div>
						<template v-if="typeof row.isVatIncluded !== 'boolean'">--</template>
						<template v-else>
							{{ row.isVatIncluded === false ? 'Сверху' : 'Включительно' }}
						</template>
					</div>
				</template>
			</template>
		</VDataGridColumnV2>

		<VDataGridColumnV2
			id="deliveryType"
			label="Условия доставки"
			width="150px"
			content-align="center"
			filterable
      filter-identity="*"
			filter-type="select"
			:filter-props="{
				placeholder: 'Выберите условия',
				clearable:   true,
				options:     this.deliveryTypeList,
			}"
			header-class="nowrap"
		>
			<template #default="{ row }">
				{{ row.deliveryType.name }}
			</template>
		</VDataGridColumnV2>

		<VDataGridColumnV2
			id="paymentType"
			width="250px"
			label="Условия оплаты"
			content-class="nowrap"
			content-align="left"
		>
			<template #default="{ row }">
				{{ row.paymentTermsText }}
				<VIcon
					v-if="row.prepaymentTerms.length > 0 || row.postpaymentTerms.length > 0"
					style="color: var(--accent-strong);"
					material="info"
					theme="outlined"
					@mouseenter="$core.tooltip.show($event.currentTarget, paymentTermsHint(row))"
					@mouseleave="$core.tooltip.hide()"
				/>
			</template>
		</VDataGridColumnV2>
	</VDataGridV2>
</template>

<script lang="ts">

import DataGridLoader            from '@/lib/components/VDataGridV2/DataGridLoader';
import ContractsExternalService  from '@/domains/Contracts/ContractsExternalService';
import Core from "@/core/Core";
import PaymentTerm from "@/domains/PaymentTerms/PaymentTerm";

export default defineComponent({
	name: 'ContractsExternalRegistry',

	data() {
		return {
			ContractsExternalService,

			dataLoader: new DataGridLoader(ContractsExternalService.getListPaginated),

			paymentTermPopup: {
				target: null as HTMLElement | null,
				entity: null as any,
			},
		};
	},

	created() {
		const { entityId } = this.$route.params;
		const contractId   = parseInt(entityId as string, 10);

		if (!isNaN(contractId)) {
			this.openManualContractDialog(contractId);
		}
	},

	computed: {
		paymentTermPopupVisible(): boolean {
			return Boolean(this.paymentTermPopup.target);
		},

		deliveryTypeList(): any[] {
			return Core.dictionaries.deliveryTypes.toArray();
		},
	},

	methods: {

		/**
		 * Текст подсказки с условиями оплаты для тултипа.
		 */

		paymentTermsHint(row: any): string {
			const lines: string[] = [];

			if (row.prepaymentTerms.length > 0) {
				lines.push(`Предоплата: ${row.prepaymentTerms.map((prepaymentTerm: PaymentTerm) => prepaymentTerm.stringRepresentation).join(', ')}`);
			}
			if (row.postpaymentTerms.length > 0) {
				lines.push(`Постоплата: ${row.postpaymentTerms.map((postpaymentTerm: PaymentTerm) => postpaymentTerm.stringRepresentation).join(', ')}`);
			}

			return lines.join('\n');
		},

		/**
		 * Открыть карточку договора — по двойному клику в строке
		 * и при deep-link открытии по параметру роута.
		 */

		async openManualContractDialog(contractId: number): Promise<void> {
			await ContractsExternalService.editContract(contractId, null);
		},
	},
});
</script>
